import { createSlice } from '@reduxjs/toolkit';
const ERROR_INITIAL = {
  hasError: false,
  error: "",
};
const initialState = {
  token: "",
  timestamp: "",
  error: ERROR_INITIAL,
};

export const tokenSlice = createSlice({
  name: "token",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    updateToken: (state, action) => {
      return {
        token: action.payload,
        timestamp: new Date().getTime(),
      };
    },
    removeToken: () => {
      return initialState;
    },
    setTokenError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { updateToken, removeToken, setTokenError } = tokenSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getToken = (state) => state.token.token;
export const getTokenData = (state) => state.token;
export const getTokenError = (state) => state?.error;

export default tokenSlice.reducer;
